// Assets
import { DownloadIcon } from '@heroicons/react/outline';

function Hero() {
    // Methods
    const openTwitter = () =>
        window.open('https://twitter.com/penzo_nicolo', '_blank', 'noopener,noreferrer');

    const openLinkedin = () =>
        window.open(
            'https://www.linkedin.com/in/nicol%C3%B2-penzo-49bab5206',
            '_blank',
            'noopener,noreferrer'
        );
	const openBSky = () =>
        window.open(
            'https://bsky.app/profile/penzo-nicolo.bsky.social',
            '_blank',
            'noopener,noreferrer'
        );
	const openScholar = () =>
        window.open(
            'https://scholar.google.com/citations?user=JXQKsH0AAAAJ&hl=en&oi=ao',
            '_blank',
            'noopener,noreferrer'
        );
const openGithub = () =>
        window.open(
            'https://github.com/nicolopenzo',
            '_blank',
            'noopener,noreferrer'
        );

const openOrcid = () =>
        window.open(
            'https://orcid.org/0009-0006-8648-3307',
            '_blank',
            'noopener,noreferrer'
        );

    // Render
    return (
        <div id='info'>
            <div className='bold my-16 text-5xl text-gray-900 relative'>
                <div className='absolute lg:-translate-x-24 hidden xl:block'>
                    <img
                        src={require('../assets/x2.png')}
                        alt='twitter-icon'
                        className='w-6 h-6 cursor-pointer mb-3 mt-2'
                        onClick={openTwitter}
                    />
                    <img
                        src={require('../assets/linkedin2.png')}
                        alt='linkedin-icon'
                        className='w-6 h-6 cursor-pointer mb-3 mt-2'
                        onClick={openLinkedin}
                    />
			<img
                        src={require('../assets/bluesky.png')}
                        alt='bsky-icon'
                        className='w-6 h-6 cursor-pointer mb-3 mt-2'
                        onClick={openBSky}
                    />
		<img
                        src={require('../assets/scholar.png')}
                        alt='scholar-icon'
                        className='w-6 h-6 cursor-pointer mb-3 mt-2'
                        onClick={openScholar}
                    />
		<img
                        src={require('../assets/github.png')}
                        alt='github-icon'
                        className='w-6 h-6 cursor-pointer mb-3 mt-2'
                        onClick={openGithub}
                    />
		<img
                        src={require('../assets/orcid.png')}
                        alt='orcid-icon'
                        className='w-6 h-6 cursor-pointer'
                        onClick={openOrcid}
                    />
                </div>
		<h1 className='mb-3'>PhD Student</h1>
                <h1 className='mb-3'>Natural Language Processing</h1>
                <h1 className='mb-3'>Computational Social Science</h1>
            </div>
            <div className='flex flex-col lg:flex-row space-y-12 lg:space-y-0'>
                <div className='w-full lg:w-2/5'>
                    {/* <div className='bg-gray-400 w-full h-96' /> */}
                    <img
                        src={require('../assets/profileImage2.jpg')}
                        alt='profile-image'
                        className='h-auto w-full cursor-pointer'
                    />
                </div>
                <div className='w-full lg:w-4/5 lg:px-10'>
                    <h2 className='text-2xl font-semibold mb-3 text-gray-900'>Biography</h2>
                    <p className='mb-3'>
                        Hi! I'm a PhD student at Fondazione Bruno Kessler and University of Trento, working on the Natural Language Processing field. My research focuses on Multi-Party Conversations and toxic behaviors on social media, exploring how NLP can merge with network and complex systems analysis. More broadly, I'm contributing to the Computational Social Science field for better understanding online interactions.
		    </p>
		    <p>
			Feel free to get in touch!
                    </p>
                </div>
                <div className='w-full lg:w-1/5'>
                    <h2 className='text-2xl font-semibold mb-3 text-gray-900'>Informations</h2>
                    <div className='flex mb-2'>
                        <p className='font-bold mr-2 text-gray-900'>Name:</p>
                        <p>Nicolò Penzo</p>
                    </div>
                    <div className='flex mb-2'>
                        <p className='font-bold mr-2 text-gray-900'>Birth:</p>
                        <p>29/10/1998</p>
                    </div>
                    <div className='flex mb-2'>
                        <p className='font-bold mr-2 text-gray-900'>Email:</p>
                        <p>npenzo@fbk.eu</p>
                    </div>
                    <div className='flex mb-2'>
                        <p className='font-bold mr-2 text-gray-900'>Address:</p>
                        <p>Isola Vicentina(VI), Italy</p>
                    </div>
                    <div className='flex xl:hidden mt-4'>
                        <img
                            src={require('../assets/x2.png')}
                            alt='twitter'
                            className='w-6 h-6 cursor-pointer mr-2'
                            onClick={openTwitter}
                        />
                        <img
                            src={require('../assets/linkedin2.png')}
                            alt='linkedin'
                            className='w-6 h-6 cursor-pointer mr-2'
                            onClick={openLinkedin}
                        />
<img
                        src={require('../assets/bluesky.png')}
                        alt='bsky-icon'
                        className='w-6 h-6 cursor-pointer mr-2'
                        onClick={openBSky}
                    />
		<img
                        src={require('../assets/scholar.png')}
                        alt='scholar-icon'
                        className='w-6 h-6 cursor-pointer mr-2'
                        onClick={openScholar}
                    />
		<img
                        src={require('../assets/github.png')}
                        alt='github-icon'
                        className='w-6 h-6 cursor-pointer mr-2'
                        onClick={openGithub}
                    />
		<img
                        src={require('../assets/orcid.png')}
                        alt='orcid-icon'
                        className='w-6 h-6 cursor-pointer'
                        onClick={openOrcid}
                    />
                    </div>
                    <div className='flex'>
                        <div className='flex items-center mt-12 cursor-pointer bg-gray-200 px-3 py-2 rounded hover:bg-white transition-all'>
                            <DownloadIcon className='text-gray-900 h-6' />
                            <a
                                className='ml-3 italic underline'
                                href={process.env.PUBLIC_URL + '/cv.pdf'}>
                                Download resume
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Hero;
